export default __webpack_public_path__ + "static/careers-olga-signature-beeba212a529b48bdde82059fa261ac5.svg";